import * as THREE from 'three';
import { offscreen } from './platform.js';
import { drawNavIcon, UI_COLORS } from './uiArt.js';

export function touchPadLayout(screen, nav) {
  const safe = screen.safeArea || {}, size = screen.height < 500 ? 76 : 88;
  const y = nav.y - size - 14;
  return { move: { x: (safe.left || 0) + 18, y, width: size, height: size },
    action: { x: screen.width - (safe.right || 0) - size - 18, y: y + 8, width: size, height: size - 8 } };
}

export function stickVector(rect, point) {
  const x = (point.x - rect.x - rect.width / 2) / (rect.width * .33);
  const y = (point.y - rect.y - rect.height / 2) / (rect.height * .33);
  const length = Math.hypot(x, y);
  return length < .16 ? { x: 0, y: 0 } : { x: x / Math.max(1, length), y: y / Math.max(1, length) };
}

export function createTouchControls(hudScene, { onInteract, onStop }) {
  const make = () => {
    const canvas = offscreen(200, 200), texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    const sprite = new THREE.Sprite(new THREE.SpriteMaterial({ map: texture, depthTest: false, depthWrite: false }));
    sprite.center.set(0, 1); sprite.renderOrder = 5; hudScene.add(sprite);
    return { canvas, texture, sprite };
  };
  const pad = make(), action = make();
  let enabled = false, rects, moveId = null, actionId = null, actionOrigin, actionMoved = false, vector = { x: 0, y: 0 }, lastPaint = '';
  const contains = (r, p) => Math.hypot((p.x-r.x-r.width/2)/(r.width/2),(p.y-r.y-r.height/2)/(r.height/2)) <= 1;
  function reset() { const held = moveId != null; moveId = actionId = null; vector = { x: 0, y: 0 }; if (held) onStop(); }
  function draw(label) {
    const key = [Math.round(vector.x * 20), Math.round(vector.y * 20), label, actionId != null].join('|');
    if (key === lastPaint) return; lastPaint = key;
    for (const item of [pad, action]) {
      const ctx = item.canvas.getContext('2d'); ctx.clearRect(0,0,200,200);
      ctx.fillStyle = actionId != null && item === action ? 'rgba(183,149,70,.7)' : 'rgba(7,58,59,.50)';
      ctx.strokeStyle = 'rgba(255,235,189,.62)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(100,100,94,0,Math.PI*2); ctx.fill(); ctx.stroke();
      if (item === pad) {
        ctx.fillStyle = 'rgba(255,243,211,.82)'; ctx.beginPath(); ctx.arc(100+vector.x*40,100+vector.y*40,34,0,Math.PI*2); ctx.fill();
        for (let i=0;i<4;i++) { ctx.save();ctx.translate(100,100);ctx.rotate(i*Math.PI/2);ctx.fillStyle='rgba(243,234,211,.45)';
          ctx.beginPath();ctx.moveTo(-7,-64);ctx.lineTo(0,-76);ctx.lineTo(7,-64);ctx.fill();ctx.restore(); }
      } else {
        drawNavIcon(ctx, 'interact', 100, 83, 90);
        ctx.fillStyle = UI_COLORS.text; ctx.textAlign='center';ctx.font='500 27px sans-serif'; ctx.fillText(label || '活动',100,160,170);
      }
      item.texture.needsUpdate = true;
    }
  }
  return {
    get vector() { return vector; },
    get held() { return moveId != null || actionId != null; },
    ownsPointer(id) { return id != null && (id === moveId || id === actionId); },
    update(screen, nav, visible, label) {
      enabled = visible; pad.sprite.visible = action.sprite.visible = visible;
      if (!visible) { reset(); return; }
      rects = touchPadLayout(screen, nav);
      for (const [key, item] of [['move',pad],['action',action]]) { const r=rects[key];
        item.sprite.position.set(r.x,screen.height-r.y,.4);item.sprite.scale.set(r.width,r.height,1); }
      draw(label);
    },
    start(points) {
      if (!enabled) return false;
      for (const p of points) {
        if (p.id === moveId || p.id === actionId) continue;
        if (moveId == null && contains(rects.move,p)) { moveId = p.id; vector = stickVector(rects.move,p); }
        else if (actionId == null && contains(rects.action,p)) { actionId = p.id; actionOrigin = p; actionMoved = false; }
      }
      return moveId != null || actionId != null;
    },
    move(points) {
      const p = points.find(p=>p.id===moveId); if (p) vector=stickVector(rects.move,p);
      const a = points.find(p=>p.id===actionId); if (a && Math.hypot(a.x-actionOrigin.x,a.y-actionOrigin.y)>16) actionMoved=true;
    },
    end(points) {
      if (moveId != null && !points.some(p=>p.id===moveId)) { moveId=null;vector={x:0,y:0};onStop(); }
      if (actionId != null && !points.some(p=>p.id===actionId)) { actionId=null;if(enabled&&!actionMoved)onInteract(); }
    },
    cancel: reset,
  };
}
